// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import type {ProfileEffectCatalogResponse} from '@fluxer/schema/src/domains/user/ProfileEffectSchemas';

export async function fetchProfileEffectCatalog(): Promise<ProfileEffectCatalogResponse> {
	const response = await http.get<ProfileEffectCatalogResponse>(Endpoints.PROFILE_EFFECTS);
	return response.body;
}
